import * as React from "react";
import { WizardHotelPWAFlexComponent } from "../typings";
import { UitkCheckbox } from "uitk-react-switch";
import { locKeys } from "./l10n";
import { ILocalization } from "bernie-l10n";

export const AddFlight = ({
  flexComponent,
  changeFormProperties,
  isFlightAdded,
  l10n,
  disablePackageOptions
}: {
  flexComponent: WizardHotelPWAFlexComponent;
  isFlightAdded: boolean;
  changeFormProperties: (event: React.ChangeEvent<HTMLFormElement>) => void;
  l10n: ILocalization;
  disablePackageOptions?: boolean;
}) => {
  if (!flexComponent.model.enableAddFlight) {
    return null;
  }

  return (
    <div className="packageCheckbox all-r-padding-three">
      <UitkCheckbox
        id="addFlight"
        label={l10n.formatText(locKeys.addFlightLabel)}
        checked={isFlightAdded}
        onChange={changeFormProperties}
        disabled={disablePackageOptions}
      />
    </div>
  );
};
